import React, { useEffect, useState } from 'react'
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { TListItemWithSubMenu } from '../../../utils/types/layoutTypes'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../context/auth/AuthContextProvider'
import { PAGE_URLS } from '../../../utils/helpers/helper'

const ListItemWithSubMenu = ({
  index,
  fullPath,
  listItem,
  navMenuOpen,
  setNavMenuOpen,
}: TListItemWithSubMenu) => {
  const { user } = useAuthContext()
  const navigate = useNavigate()

  const isUserLockedToZone = user.companyId && user.companyId > 0
  const isUserLockedToDepot = user.depotId && user.depotId > 0

  const isMenuSelected = listItem.subMenus?.filter(
    (subMenu) => fullPath.indexOf(subMenu.goToUrl) >= 0
  )

  const [expandSubItems, setExpandSubItems] = useState<boolean>(
    navMenuOpen && isMenuSelected && isMenuSelected.length > 0 ? true : false
  )

  const iconMinWidth = user.companyOptions.includes('MENU_JOBS_STATUS')
    ? '40px'
    : '56px'

  // Automatically close submenus if the navMenuOpen is false
  useEffect(() => {
    if (!navMenuOpen && expandSubItems) {
      setExpandSubItems(false)
    }
  }, [expandSubItems, navMenuOpen])

  return (
    <React.Fragment>
      <Tooltip title={navMenuOpen ? '' : listItem.label} placement="right">
        <ListItemButton
          key={index}
          onClick={() => {
            if (!expandSubItems) {
              setNavMenuOpen(true)
            }
            setExpandSubItems(!expandSubItems)
          }}
        >
          <ListItemIcon sx={{ color: 'var(--white)', minWidth: iconMinWidth }}>
            {listItem.icon}
          </ListItemIcon>
          <ListItemText primary={listItem.label} />
          {expandSubItems ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>
      <Collapse in={expandSubItems} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ width: '255px' }}>
          {listItem.subMenus?.map((subMenu, idx) => {
            if (
              !subMenu.requiredCompanyOption ||
              (subMenu.requiredCompanyOption &&
                subMenu.requiredCompanyOption.find((option: string) =>
                  user.companyOptions.includes(option)
                ) !== undefined)
            ) {
              // If user locked to depot, hide depot section
              if (
                isUserLockedToDepot &&
                subMenu.goToUrl === PAGE_URLS.SETTINGS_DEPOTS
              ) {
                return ''
              }

              // If user locked to zone, hide zones section
              if (
                isUserLockedToZone &&
                subMenu.goToUrl === PAGE_URLS.SETTINGS_ZONES
              ) {
                return ''
              }

              return (
                <ListItemButton
                  key={idx}
                  sx={{ pl: 4 }}
                  selected={fullPath.indexOf(subMenu.goToUrl) >= 0}
                  onClick={() => navigate(subMenu.goToUrl)}
                >
                  <ListItemIcon
                    sx={{ color: 'var(--white)', minWidth: iconMinWidth }}
                  >
                    {subMenu.icon}
                  </ListItemIcon>
                  <ListItemText primary={subMenu.label} />
                </ListItemButton>
              )
            }

            return ''
          })}
        </List>
      </Collapse>
    </React.Fragment>
  )
}

export default ListItemWithSubMenu
